// generated by genversion
const version = '6.12.1';
export { version };
